import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

// numer bywa wpisywany z separatorami: "+48 792 572 620", "792-572-620", "(48) 792 572 620"
const stripSeparators = (value: string) => value.replace(/[\s .\-()]/g, "");

export const isValidPhoneNumber = (value: string) =>
  /^(?:(?:\+|00)?\d{2})?\d{9}$/.test(stripSeparators(value));

export function createPhoneFieldValidationSuite(
  definition: TextField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue) as string;

  if (definition.required) {
    test(createFieldName(definition), trans("form_validation.required"), () => {
      enforce(value).isString().isNotEmpty();
    });
  }

  test(createFieldName(definition), trans("form_validation.phone"), () => {
    enforce(
      !value || value.length === 0 || isValidPhoneNumber(value),
    ).isTruthy();
  });
}
